/**
 *
 * Asynchronously loads the component for ChooseProfile
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ChooseProfile = lazyLoad(
  () => import('./index'),
  module => module.ChooseProfile,
);
